<template>
  <div class="contact-us">
      <Header></Header>
      <StoreLocator></StoreLocator>
      <ContactForm></ContactForm>
      <!-- <OtherContact></OtherContact> -->
  </div>
</template>

<script>
import Header from "@/components/contact/Header.vue";
import StoreLocator from "@/components/contact/StoreLocator.vue";
import ContactForm from "@/components/contact/ContactForm.vue";

export default {
  name: "Contact",
  components: {
    Header,
    StoreLocator,
    ContactForm,
  }
};
</script>
